import { AscMarkTheWordWordsObject } from "@ascendnow/shared";
import classNames from "classnames";
import React, { useEffect } from "react";
import styles from "./AscMarkTheWordText.module.scss";

export interface AscMarkTheWordTextProps {
  className?: string;
  text: string | React.ChangeEvent<HTMLInputElement>;
  words: AscMarkTheWordWordsObject[];
  onChange: (words: AscMarkTheWordWordsObject[]) => void;
  disabled?: boolean;
  loading?: boolean;
  showCorrectAnswers?: boolean;
  attemptsCompleted?: boolean;
}

export default function AscMarkTheWordText({
  className,
  text,
  words,
  onChange,
  disabled,
  loading,
  showCorrectAnswers,
  attemptsCompleted,
}: AscMarkTheWordTextProps) {
  useEffect(() => {
    if (typeof text === "string") {
      onChange(
        text?.split(" ")?.map((word, index) => ({
          word,
          isMarked: false,
          key: index,
          value: word?.match(/[a-z-]+/gi)?.join("") || word,
          correct: undefined,
        }))
      );
    } else {
      onChange(
        text?.target.value.split(" ")?.map((word, index) => ({
          word,
          isMarked: false,
          key: index,
          value: word?.match(/[a-z-]+/gi)?.join("") || word,
          correct: undefined,
        }))
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text]);

  function handleMark(value: string) {
    if (disabled) return;
    const newWords = words?.map((wordObject) =>
      wordObject?.value === value
        ? {
            ...wordObject,
            isMarked: !wordObject?.isMarked,
          }
        : wordObject
    );
    onChange?.(newWords);
  }

  return (
    <div
      data-testid="asc-mark-the-word-text"
      className={classNames(styles.ground, className)}
    >
      {words.map((wordObject, index, { length }) => {
        if (wordObject?.word === "\n") {
          return <div className={styles.lineBreak} key={wordObject?.key} />;
        }
        return (
          <React.Fragment key={wordObject?.key}>
            <span
              onClick={() => handleMark(wordObject?.value)}
              className={classNames(styles.word, {
                [styles.marked]: wordObject?.isMarked,
                [styles.correct]:
                  wordObject?.shouldBeMarked &&
                  wordObject?.isMarked &&
                  showCorrectAnswers,
                [styles.incorrectlyMarked]:
                  !wordObject?.shouldBeMarked &&
                  wordObject?.isMarked &&
                  showCorrectAnswers,
                [styles.incorrectlyUnmarked]:
                  wordObject?.shouldBeMarked &&
                  !wordObject?.isMarked &&
                  showCorrectAnswers &&
                  attemptsCompleted,
                [styles.disabled]: disabled,
                [styles.loading]: loading,
              })}
              dangerouslySetInnerHTML={{ __html: wordObject?.word }}
            />

            {index === length - 1 ? null : " "}
          </React.Fragment>
        );
      })}
    </div>
  );
}
